const CAPTCHA_KEY = '6LdOVrIZAAAAAEeF-vWn8QLrfFi8QJ0NFH9UB9xJ'

const DEMO_REQUEST = {
    formAction: 'https://kubevious.us17.list-manage.com/subscribe/post-json?u=0f66db27d51536cbe358b3e93&amp;id=0b9f850cc7&c=?',
    mainTitle: 'Demo Request',
    subTitle: 'If you want to see Kubevious demo, reach out to our team by submitting the request below.',
    hubspotPortalId: '21176504',
    hubspotFormId: '0cfd1b5a-ea8b-4b89-98a2-2f2b29248786',
    hubspotMeetingUrl: 'https://meetings.hubspot.com/ruben-hakopian?embed=true',
}

const CONTACT_PAGE = {
    formAction: 'https://kubevious.us17.list-manage.com/subscribe/post-json?u=0f66db27d51536cbe358b3e93&amp;id=b19153bac8&c=?',
    mainTitle: 'How can we help?',
    hubspotPortalId: '21176504',
    hubspotFormId: '53b55302-5f93-4060-99d2-4e8d15fc701f',
}

const ALL_CONTACT_PAGES = [
    DEMO_REQUEST,
    CONTACT_PAGE
]

module.exports.DEMO_REQUEST = DEMO_REQUEST
module.exports.CONTACT_PAGE = CONTACT_PAGE
module.exports.ALL_CONTACT_PAGES = ALL_CONTACT_PAGES
module.exports.CAPTCHA_KEY = CAPTCHA_KEY
